import React from 'react';

const SuccessModal = ({ isOpen, onClose, title, message, buttonText = "Tamam", type = "success" }) => {
    if (!isOpen) return null;

    const isError = type === "error";

    return (
        <div className="fixed inset-0 z-[420] flex items-center justify-center px-4" onClick={(e) => e.target === e.currentTarget && onClose()}>
            <div className="absolute inset-0 bg-black/80 backdrop-blur-md transition-opacity"></div>

            <div className="relative bg-white dark:bg-[#1a1a1a] rounded-[2.5rem] w-full max-w-sm p-8 shadow-2xl animate-fade-in-up border-4 border-slate-50 dark:border-gray-800 text-center">
                {/* Simple Close Icon */}
                <button
                    onClick={onClose}
                    className="absolute top-6 right-6 p-2 text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 transition-colors"
                >
                    <span className="material-symbols-outlined text-[24px]">close</span>
                </button>

                {/* Decoration */}
                <div className="absolute top-0 right-0 w-32 h-32 bg-primary/5 rounded-full blur-3xl -mr-16 -mt-16"></div>

                <div className={`size-24 ${isError ? 'bg-red-50 dark:bg-red-900/20 text-red-500' : 'bg-green-50 dark:bg-green-900/20 text-green-500'} rounded-full flex items-center justify-center mx-auto mb-8 shadow-xl shadow-current/5 ring-8 ring-white dark:ring-[#1a1a1a]`}>
                    <span className="material-symbols-outlined text-5xl">
                        {isError ? 'error' : 'check_circle'}
                    </span>
                </div>

                <h3 className="text-2xl font-black text-slate-900 dark:text-white mb-3 uppercase tracking-tight">
                    {title || (isError ? 'Hata!' : 'Harika!')}
                </h3>

                <p className="text-slate-500 dark:text-gray-400 font-bold mb-8 leading-relaxed text-sm">
                    {message}
                </p>

                <button
                    onClick={onClose}
                    className={`w-full h-14 rounded-2xl ${isError ? 'bg-red-500 shadow-red-500/30' : 'bg-green-500 shadow-green-500/30'} text-white font-black text-xs uppercase tracking-widest shadow-xl hover:scale-[1.02] active:scale-[0.98] transition-all flex items-center justify-center gap-2`}
                >
                    <span className="material-symbols-outlined text-lg">
                        {isError ? 'close' : 'done_all'}
                    </span>
                    {buttonText}
                </button>
            </div>
        </div>
    );
};

export default SuccessModal;
